// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"yK","blender_bottle_img":"zK","blender_bottle_info":"AK","blender_bottle_title":"BK","blender_bottle_bold":"CK","blender_bottle_usual":"EK","blender_bottle_item_mob":"FK","addbutton":"GK","blender_bottle_title_mob":"HK","blender_bottle_bold_mob":"IK","blender_bottle_usual_mob":"JK","bolder":"KK","bottom_margin_4":"LK","bottom_margin_16":"MK"};
    if(module.hot) {
      // 1730991508648
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  